import React, { useRef } from 'react';

import { HStack, Input, SpinnerButton, VStack } from "~/native-ui";
import { connect } from '~/redux/connect'
import { updatePassword } from "~/rx/password";

export const ResetPasswordForm = connect(null, {updatePassword})(({trans, updatePassword, labels}) => {
    const isSubmitting = false;
    const formValuesRef = useRef({});
    
    const onSubmit = async (e) => {
        e.preventDefault();
        updatePassword(formValuesRef.current);
    };

    const setPassword = (password) => {
        formValuesRef.current.password = password;
    };
    const setPasswordConfirmation = (password) => {
        formValuesRef.current.passwordConfirmation = password;
    };


    return (
        <form onSubmit={onSubmit} >
            <VStack space={4}>
                <Input disabled={isSubmitting} onSubmitEditing={onSubmit} type="password" onChange={setPassword} placeholder={labels.password} />
                <Input disabled={isSubmitting} onSubmitEditing={onSubmit} type="password" onChange={setPasswordConfirmation} placeholder={labels.confirmPassword} />
                <HStack>
                    <SpinnerButton
                        disabled={isSubmitting}
                        icon={isSubmitting ? 'spinning' : ''}
                        onClick={onSubmit}
                        label={labels.submitButton}
                        type="submit"
                        variant="solid"
                        paddingLeft="4"
                        paddingRight="4"
                        _stack={{ space: "2" }}
                        primary
                        raised
                    />
                </HStack>
            </VStack>
        </form>
    )
});